import { Announcement } from 'src/modules/common/types/Announcement';
import { createActions } from 'src/utils/createActions';
import { createTrigger } from 'src/utils/createTrigger';

export const ANNOUNCEMENTS_FETCH = createTrigger<ReadonlyArray<Announcement>>('ANNOUNCEMENTS_FETCH');
export const ANNOUNCEMENTS_READ = createActions<void, void>('ANNOUNCEMENTS_READ');
